import { useEffect, useState } from 'react';

// This hook returns true/false based on whether the user has passed target element by scrolling
const useElementScrolled = ({
  scrollableElementRef,
  targetRef,
  threshold = 150,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const scrollableElement = scrollableElementRef?.current || null;
    // target is element we are tracking visibility against (e.g. upsell card)
    const target = targetRef?.current || null;
    if (!scrollableElement) return;
    if (!target) {
      setIsScrolled(true);
      return;
    }

    if (target) {
      const update = () => {
        const targetBottom = target.offsetTop + target.offsetHeight - threshold;
        setIsScrolled(scrollableElement.scrollTop > targetBottom);
      };

      update();
      scrollableElement.addEventListener('scroll', update, { passive: true });
      return () => scrollableElement.removeEventListener('scroll', update);
    }

    setIsScrolled(false);
  }, [scrollableElementRef, targetRef, threshold]);

  return {
    isElementScrolled: isScrolled,
  };
};

export default useElementScrolled;
